/**
 * The various major z-index layers, adjust with caution and leave space between to add to later.
 */
export const Layers = {
    Notification: 99,
    Nav: 100,
    Modal: 1000,
};
